/* eslint-disable max-len */
/* eslint-disable no-plusplus */
/* eslint-disable func-names */
/* eslint-disable no-loop-func */
import $ from 'jquery';
import {
    debounce, filter, get, sortBy, startsWith, find,
} from 'lodash';
import {
    CLASS_NAME_ERROR_TAG, CLASS_NAME_FIELD_TO_BE_FIXED, DOM_EVENT_CLICK,
    DOM_EVENT_COMPOSITION_END, DOM_EVENT_COMPOSITION_START,

    DOM_EVENT_INPUT,

    DOM_EVENT_MOUSE_LEAVE, DOM_EVENT_MOUSE_MOVE,

    SELECTOR_EDITOR_CONTAINER, SELECTOR_FIELD_TO_BE_FIXED,
    HOVER_LIGHT_CLASS,
    HOVER_LIGHT_ACTIVE_CLASS,
    DOM_EVENT_MOUSE_ENTER,
    DOM_EVENT_MOUSE_OUT,
} from '../constants';
import { getFieldList, getSearchFieldsByServiceArea, getRDSearchFieldsByServiceArea } from '../core/config/index';
import {
    getRange,
    setRange,
} from '../core/utils/selection-ranges';
import { getHtmlStrByExpressionTree } from '../core/utils/smartSearchUtils';

export default {
    data() {
        return {
            divModeMixin__isInputing: false,
            divModeMixin__tipData: null,
            range: {
                start: 0,
                end: 0,
            },
            divModeMixin__hasError: false,
        };
    },
    methods: {
        divModeMixin__bindInputEvents() {
            const vm = this;
            // 中文输入时需要使用该事件
            this.$editor
                .off(DOM_EVENT_COMPOSITION_START).on(DOM_EVENT_COMPOSITION_START, () => {
                    this.divModeMixin__isInputing = true;
                })
                .off(DOM_EVENT_COMPOSITION_END).on(DOM_EVENT_COMPOSITION_END, () => {
                    this.divModeMixin__isInputing = false;
                })
                .off(DOM_EVENT_INPUT)
                .on(DOM_EVENT_INPUT, this.divModeMixin__preUpdateQuery);

            this.$editor.parent('.ai-common-smart-search')
                .off(DOM_EVENT_MOUSE_LEAVE).on(DOM_EVENT_MOUSE_LEAVE, '.editor-container--show-error .error', this.divModeMixin__clearErrorTip)
                .on(DOM_EVENT_MOUSE_LEAVE, '.querySymbol', () => {
                    vm.divModeMixin_clearSymbolTip(true);
                })
                .on(DOM_EVENT_MOUSE_LEAVE, '.field:not(.error)', () => {
                    vm.divModeMixin_clearFieldTip(true);
                })
                .off(DOM_EVENT_MOUSE_MOVE)
                .on(DOM_EVENT_MOUSE_MOVE, '.editor-container--show-error .error', function (e) {
                    vm.divModeMixin__showErrorTip(this, e);
                })
                .on(DOM_EVENT_MOUSE_MOVE, '.querySymbol', (e) => {
                    vm.divModeMixin_showSymbolTip(e);
                })
                .on(DOM_EVENT_MOUSE_MOVE, '.field:not(.error)', (e) => {
                    vm.divModeMixin_showFieldTip(e);
                })
                .off(DOM_EVENT_CLICK)
                .on(DOM_EVENT_CLICK, '.editor-container--show-error .field.error', function () {
                    if (!vm.contenteditable) return;
                    const errorCode = $(this).attr('data-error-code');
                    if (errorCode === '10001') {
                        vm.divModeMixin__clearErrorTip();
                        vm.divModeMixin__showAlternativeFields(this);
                    }
                });
        },
        // input事件 输入文本转换query
        divModeMixin__preUpdateQuery: debounce(function () {
            if (this.divModeMixin__isInputing) return;
            let query = this.$node.textContent;
            query = query.replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            this.inputModeMixin__query = query;
            this.divModeMixin__updateQuery();
            this.updateQuery(query);
            this.isInputing = true;
        }, 10),
        divModeMixin__updateQuery: debounce(function () {
            if (this.divModeMixin__isInputing) return;
            // 光标位置
            const range = this.divModeMixin__getRange();
            let query = this.$node.textContent;
            query = query.replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            this.isInputing = false;
            this.setQuery(query, range);
            this.divModeMixin__clearErrorTip();
        }, 250),
        divModeMixin__updateDOM() {
            if (this.divModeMixin__isInputing) return;
            const htmlStr = getHtmlStrByExpressionTree(this.expressionTree, this.range);
            this.$node.innerHTML = htmlStr;

            // 没用到
            this.divModeMixin__hasError = Boolean($(htmlStr).find('.error').length);
        },
        divMixin__scrollToFocus() {
            const position = this.divMixin__getRangePosition();
            if (!position) return;
            const tdHeight = position.height;
            const tdTop = position.top;
            const editorHeight = this.$el.offsetHeight;
            const { scrollTop } = this.$node;
            if (editorHeight + scrollTop < tdHeight + tdTop + 30) {
                this.$node.scrollTop = tdHeight + tdTop - editorHeight + 30;
            }
        },
        // eslint-disable-next-line consistent-return
        divMixin__getRangePosition() {
            const cursorWordData = this.suggestionInstance.getCursorWordData(this.range);
            const tokenId = get(cursorWordData, 'cursorToken.data.id');
            const nextToken = '<span class="ed_position_token"></span>';
            $(`.ed_tk_${tokenId}`).append(nextToken);
            const focusDom = this.$el.querySelector('.ed_position_token');
            let position = {
                height: 0,
                width: 0,
                top: 0,
                left: 0,
            };
            if (tokenId && focusDom) {
                position = {
                    height: focusDom.offsetHeight,
                    width: focusDom.offsetWidth,
                    top: focusDom.offsetTop,
                    left: focusDom.offsetLeft,
                };
                $('.editor-container').find('.ed_position_token').remove();
                return position;
            }
            $('.editor-container').find('.ed_position_token').remove();
        },
        divModeMixin__setRange(range) {
            setRange(this.$node, range);
        },
        divModeMixin__getRange() {
            return getRange(this.$node);
        },
        divModeMixin__clearFieldList() {
            this.fieldList = [];
            const range = this.range || this.divModeMixin__getRange();
            const query = this.$node.textContent;
            this.setQuery(query, range);
        },
        divModeMixin__getSuggestFields(value) {
            let maxChar = 0;
            let suggestWords = [];
            const maxWords = 0;
            for (let i = 0; i <= value.length; i++) {
                maxChar = i;
                suggestWords = filter(getFieldList(this.config.isRDVersion), (item) => startsWith(item, value.substring(0, maxChar + 1).toUpperCase()));
                if (i === value.length) {
                    maxChar = value.length;
                }
                if (suggestWords.length <= maxWords) {
                    break;
                }
            }
            suggestWords = filter(getFieldList(this.config.isRDVersion), (item) => startsWith(item, value.substring(0, maxChar).toUpperCase()));
            suggestWords = sortBy(suggestWords, (item) => item);
            return suggestWords;
        },
        divModeMixin__clearErrorTip() {
            this.divModeMixin__tipData = null;
        },
        divModeMixin__showErrorTip(dom, e) {
            const $jq = $(dom);
            if ($jq.hasClass(CLASS_NAME_FIELD_TO_BE_FIXED)) {
                return;
            }
            this.divModeMixin__tipData = {
                type: 'error',
                target: e,
                message: this.$t(`smartSearch.errorCode.${$jq.data('error-code')}`),
            };
        },
        divModeMixin_clearSymbolTip: debounce(function (needRemove) {
            if (needRemove) {
                this.divModeMixin__tipData = null;
            }
        }, 50),
        divModeMixin_showSymbolTip(e) {
            const $jq = $(e.target);
            if ($jq.hasClass(CLASS_NAME_ERROR_TAG)) {
                return;
            }
            const symbol = e.target.textContent;
            const message = this.querySymbol.getQueryBySymbol(symbol);
            this.divModeMixin__tipData = message ? {
                type: 'normal',
                target: e,
                message,
            } : null;
        },
        divModeMixin_clearFieldTip: debounce(function (needRemove) {
            if (needRemove) {
                this.divModeMixin__tipData = null;
            }
        }, 50),
        divModeMixin_showFieldTip(e) {
            const $jq = $(e.target);
            if ($jq.hasClass(CLASS_NAME_ERROR_TAG)) {
                return;
            }
            const field = e.target.textContent.toLocaleUpperCase();
            const fieldsList = this.config.isRDVersion ? getRDSearchFieldsByServiceArea() : getSearchFieldsByServiceArea();
            const fieldItem = find(fieldsList, { name: field });
            const message = get(fieldItem, `desc.${this.$i18n.locale}`);
            this.divModeMixin__tipData = message ? {
                type: 'normal',
                target: e,
                message,
            } : null;
        },
        divModeMixin__showAlternativeFields(dom) {
            this.range = this.divModeMixin__getRange();
            const $jq = $(dom);
            if ($jq.hasClass(CLASS_NAME_FIELD_TO_BE_FIXED)) {
                $jq.removeClass(CLASS_NAME_FIELD_TO_BE_FIXED);
                this.fieldList = [];
                return;
            }
            const { offsetLeft, offsetTop, offsetHeight } = dom;
            const $editorContainer = $jq.parents(SELECTOR_EDITOR_CONTAINER)[0];
            const top = `${offsetHeight + offsetTop - $editorContainer.scrollTop}px`;
            const left = `${offsetLeft - $editorContainer.scrollLeft - 20}px`;
            $(SELECTOR_FIELD_TO_BE_FIXED).removeClass(CLASS_NAME_FIELD_TO_BE_FIXED);
            $jq.addClass(CLASS_NAME_FIELD_TO_BE_FIXED);
            const text = $jq.text();
            this.fieldList = this.divModeMixin__getSuggestFields(text);
            this.fieldListPos = { top, left };
        },
        operatorMouseenter(e) {
            $(e.currentTarget).addClass(HOVER_LIGHT_ACTIVE_CLASS);
            const siblings = $(e.currentTarget).siblings();
            const matchedSiblings = siblings.filter(`.${HOVER_LIGHT_CLASS}`);
            matchedSiblings.each((index, domEle) => $(domEle).addClass(HOVER_LIGHT_ACTIVE_CLASS));
        },
        operatorMouseout(e) {
            $(e.currentTarget).removeClass(HOVER_LIGHT_ACTIVE_CLASS);
            const siblings = $(e.currentTarget).siblings();
            const matchedSiblings = siblings.filter(`.${HOVER_LIGHT_CLASS}`);
            matchedSiblings.each((index, domEle) => $(domEle).removeClass(HOVER_LIGHT_ACTIVE_CLASS));
        },
    },
    mounted() {
        $(this.$el).on(DOM_EVENT_MOUSE_ENTER, `.${HOVER_LIGHT_CLASS}`, this.operatorMouseenter);
        $(this.$el).on(DOM_EVENT_MOUSE_OUT, `.${HOVER_LIGHT_CLASS}`, this.operatorMouseout);
    },
};
